"use client";

import { Post } from "@forcode/domain";
import { Image, Link } from "ui";

interface PostCardMediaProps {
  post: Post;
}

export default function PostCardMedia({ post }: PostCardMediaProps) {
  const { image, title, urlSlug } = post;

  return (
    <Link href={urlSlug}>
      <Image
        alt={title}
        src={image.src}
        provider={image.provider}
        width={382}
        height={142}
      />
    </Link>
  );
}
